import { format, isValid, parseISO } from 'date-fns';
import { EM_DASH } from '../../utils/formatDate';

/**
 * Display formats for bids (ticket #295). bidDueAt, createdAt and updatedAt
 * are timestamps (ISO strings), shown in local time — not calendar dates, so
 * formatDate() from utils/formatDate does not apply.
 */

const toDate = (value) => {
  if (!value) return null;
  const date = typeof value === 'string' ? parseISO(value) : value;
  return isValid(date) ? date : null;
};

/** { date: '10/27/2026', time: '11:00 AM' }, or null when there is no due date. */
export const formatBidDue = (value) => {
  const date = toDate(value);
  return date
    ? { date: format(date, 'MM/dd/yyyy'), time: format(date, 'h:mm a') }
    : null;
};

/** '10/27/2026 · 11:00 AM', or an em dash. */
export const formatBidDueText = (value) => {
  const due = formatBidDue(value);
  return due ? `${due.date} · ${due.time}` : EM_DASH;
};

/** 'Oct 17', or an em dash. For grid cells. */
export const formatMonthDay = (value) => {
  const date = toDate(value);
  return date ? format(date, 'MMM d') : EM_DASH;
};

/** 'Oct 18, 2026', or an em dash. For "Updated … by …" lines. */
export const formatLongDay = (value) => {
  const date = toDate(value);
  return date ? format(date, 'MMM d, yyyy') : EM_DASH;
};

/** '210 Mech', or an em dash. */
export const divisionLabel = (division) =>
  division ? `${division.code} ${division.name}` : EM_DASH;
